<template>
  <div style="padding: 20px; background: #fff">
    <!-- tabs 栏 -->
    <div style="display: flex;justify-content: space-between">
      <div class="custom-tabs">
        <div
          v-for="(tab, index) in tabList"
          :key="index"
          :class="['tab-item', query.material_type === tab.value ? 'active' : '']"
          @click="changeTab(tab.value)"
        >
          {{ tab.label }}
        </div>
      </div>
      <div><!--<el-input v-model="keyword" style="width: 200px"></el-input>--> <!--<el-button type="primary" @click="search">查询</el-button>-->
        <el-checkbox
          :indeterminate="isIndeterminate"
          :checked="isChecked"
          @change="handleToggleAll"
        >
          全选
        </el-checkbox>
        <el-button type="text">已选{{ selectItems.length }}</el-button>
        <el-button
          type="success"
          icon="el-icon-upload"
          style="margin-left: 10px"
          @click="addStrategy"
        >上传</el-button>
      </div>
    </div>
    <div class="line" />
    <!-- <div style="padding: 20px 0;display: flex;flex-wrap: wrap">
      <div v-for="(tab, index) in table_data" :key="index" class="item_box" @click="selectTab(tab)">
        <el-checkbox style="position: absolute;right: 5px;top: 0" :value="selectItems.includes(tab)" @click.native.stop></el-checkbox>
        <div class="item_box_head">
          <el-image
            class="el_img"
            fit="cover"
            :src="tab.pic_list[0]"
          />
        </div>
        <div class="item_box_body">
          <div class="item_bd_name">
            <div>{{ tab.play_name }}</div>
            <div>id: {{ tab.material_id }}</div>
          </div>
          <div class="item_bd_time">{{ tab.created_at }}</div>
          <div class="item_bd_det" @click.stop="linkToInfo(tab)">详情</div>
        </div>
      </div>
    </div> -->

    <!-- 数据展示区域 -->
    <div style="display: flex;flex-wrap: wrap">
      <div
        v-for="(item, index) in table_data"
        :key="index"
        style="width: 438px;height: 412px;margin: 10px 8px;background-color: #FFFFFF;border-radius: 5px;border: 1px solid rgb(240, 242, 245);"
      >
        <div
          v-if="item.upload_status!=1"
          style="height: 78px;display: flex;justify-content: space-between;padding: 10px 15px;cursor: pointer"
          @click.stop="selectTab(item)"
        >
          <div style="display: flex;align-items: center;">
            <img
              :src="item.product_icon"
              alt=""
              style="width: 44px;height: 44px;border-radius:50%"
            >
            <div style="flex-direction: column;justify-content: center;align-items: center;margin-left: 10px">
              <div style="margin-bottom:7px;font-weight:600;font-size:16px">{{ item.product_name }}</div>
              <img
                v-for="(items, indexr) in item.media_details"
                :key="indexr"
                style="width: 21px;height: 21px"
                :src="items.media_logo"
                alt=""
              >
            </div>
          </div>
          <div style="text-align: end">
            <!-- <el-checkbox
              v-if="item.upload_status!=1"
              :value="selectedItems.includes(item)"
              style="pointer-events: none"
              @click.native.stop
            />
            <el-tag
              v-else
              type="success"
            >已上传</el-tag> -->
            <el-checkbox
              style="pointer-events: none"
              :value="selectItems.includes(item)"
              @click.native.stop
            />
            <div style="margin-top: 8px;font-size: 12px;max-width: 204px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">{{ item.publisher_name }}</div>
          </div>
        </div>

        <div
          v-else
          style="height: 78px;display: flex;justify-content: space-between;padding: 10px 15px;cursor: pointer"
        >
          <div style="display: flex;align-items: center;">
            <img
              :src="item.product_icon"
              alt=""
              style="width: 44px;height: 44px;border-radius:50%"
            >
            <div style="flex-direction: column;justify-content: center;align-items: center;margin-left: 10px">
              <div style="margin-bottom:7px;font-weight:600;font-size:16px">{{ item.product_name }}</div>
              <img
                v-for="(items, indexr) in item.media_details"
                :key="indexr"
                style="width: 21px;height: 21px;margin-right:10px"
                :src="items.media_logo"
                alt=""
              >
            </div>
          </div>
          <div style="text-align: end">
            <el-tag type="success">已上传</el-tag>
            <div style="margin-top: 8px;font-size: 12px;max-width: 204px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">{{ item.publisher_name }}</div>
          </div>
        </div>
        <div
          style="cursor: pointer;position: relative;"
          @click="itemInfo(item)"
        >
          <el-image
            :src="item.pic_list[0]"
            :alt="item.pic_list[0]"
            referrerpolicy="no-referrer"
            style="width: 438px;height: 180px"
            fit="cover"
          />
          <div style="position: absolute;bottom:0px;left:0px;display: flex;background-color: rgba(0, 0, 0, 0.3);padding: 10px 30px;width: 100%;justify-content: space-between;">
            <div>
              <img
                style="width:20px;height:20px;margin-right:5px"
                src="@/assets/images/adx/player.png"
                alt=""
                srcset=""
              >
              <span style="color:white">{{ item.play_num }}</span>
            </div>
            <div> <img
                    style="width:20px;height:20px;margin-right:5px"
                    src="@/assets/images/adx/like.png"
                    alt=""
                    srcset=""
                  >
              <span style="color:white">{{ item.like_num }}</span>
            </div>
            <div> <img
                    style="width:20px;height:20px;margin-right:5px"
                    src="@/assets/images/adx/comment.png"
                    alt=""
                    srcset=""
                  >
              <span style="color:white">{{ item.comment_num }}</span>
            </div>
            <div> <img
                    style="width:20px;height:20px;margin-right:5px"
                    src="@/assets/images/adx/forward.png"
                    alt=""
                    srcset=""
                  >
              <span style="color:white">{{ item.forward_num }}</span>
            </div>
          </div>
        </div>

        <!--        <div style="height: 154px">{{ item.description }}-->
        <!--&lt;!&ndash;          <video :src="item.video_list[0]" controls crossorigin="anonymous"></video>&ndash;&gt;-->
        <!--          <iframe :src="item.video_list[0]" frameborder="0" allowfullscreen></iframe>-->
        <!--        </div>-->
        <div
          style="height: 154px;padding: 20px 0;cursor: pointer"
          @click="itemInfo(item)"
        >
          <!-- <div style="height: 60px;font-size: 16px;line-height: 25px;padding: 0 20px">
            <div style="color: #1D2129;">{{ item.title }}</div>
            <div style="color: #86909C;width: 100%;height: 50%;overflow: hidden">{{ item.description }}</div>
          </div> -->
          <div style="height: 60px; font-size: 16px; line-height: 25px; padding: 0 20px;">
            <div
              style="color: #1D2129;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;overflow: hidden;text-overflow: ellipsis;"
              v-html="item.title"
            />
          </div>
          <div class="data-row">
            <div class="item">
              <div class="value">{{ item.exposure_num }}</div>
              <div class="label">曝光量</div>
            </div>
            <div class="divider" />
            <div class="item">
              <div class="value">{{ item.appear_day }}</div>
              <div class="label">出现天数</div>
            </div>
            <div class="divider" />
            <div class="item">
              <div class="value">{{ item.material_days }}</div>
              <div class="label">投放天数</div>
            </div>
            <div class="divider" />
            <div class="item">
              <div class="value">{{ item.creative_num }}</div>
              <div class="label">计划数</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <pagination-right
      :total="total"
      :page-sizes="[30]"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
    <el-dialog
      :visible.sync="info_visible"
      :destroy-on-close="true"
      width="1000px"
      title="素材详情"
    >
      <Info ref="matinfo" />
    </el-dialog>
  </div>
</template>

<script>
import { materialInfoList, moreMaterialInfoList, uploadMaterial } from '@/api/report/adx'
import PaginationRight from '@/components/PaginationRight/index.vue'
import Info from '../components/info.vue'
export default {
  components: { PaginationRight, Info },
  data() {
    return {
      tabList: [
        { label: '全部', value: '' },
        { label: '图片', value: '1' },
        { label: '视频', value: '2' }
      ],
      query: {
        page: 1,
        pageSize: 30,
        material_type: '',
        playlet_id: null,
        strategy_no: null
      },
      total: 0,
      table_data: [],
      keyword: null,
      selectItems: [],
      currentFetchMethod: null,
      info_visible: false
    }
  },
  computed: {
    // isChecked() {
    //   const list = this.table_data?.list || []
    //   return list.length > 0 && this.selectItems.length === list.length
    // },
    // isIndeterminate() {
    //   const list = this.table_data?.list || []
    //   return this.selectItems.length > 0 && this.selectItems.length < list.length
    // }
    isChecked() {
      return this.table_data.length > 0 && this.selectItems.length === this.table_data.length
    },
    isIndeterminate() {
      return this.selectItems.length > 0 && this.selectItems.length < this.table_data.length
    }
  },
  created() {
    // 初始化查询参数
    this.query.playlet_id = this.$route.query.playlet_id || null
    this.query.strategy_no = this.$route.query.strategy_no || null

    // 根据参数决定使用哪个数据获取方法
    if (this.query.playlet_id) {
      this.currentFetchMethod = 'list'
      this.list()
    } else if (this.query.strategy_no) {
      this.currentFetchMethod = 'moreList'
      this.moreList()
    } else {
      // 处理没有参数的情况（可选）
      this.$message.error('当前页面数据丢失，请重新进入')
    }
  },
  methods: {
    fetchData() {
      if (this.currentFetchMethod === 'list') {
        this.list()
      } else if (this.currentFetchMethod === 'moreList') {
        this.moreList()
      }
    },
    changeTab(val) {
      this.selectItems = []
      this.query.material_type = val
      this.query.page = 1
      // 这里你可以直接 this.getList(val)
      this.fetchData()
    },
    list() {
      materialInfoList(this.query).then(res => {
        console.log(res)
        this.table_data = res.data.list
        this.total = res.data.total
      })
    },
    moreList() {
      moreMaterialInfoList(this.query).then(res => {
        console.log(res, 22)
        this.table_data = res.data.list
        this.total = res.data.total
      })
    },
    search() {
      this.fetchData()
    },
    addStrategy() {
      // const material_nos = this.selectItems.map(item => item.material_id)
      const material_nos = this.selectItems.map(item => item.material_no)
      console.log(material_nos)
      uploadMaterial({ material_nos: material_nos }).then(res => {
        console.log(res)
        // eslint-disable-next-line eqeqeq
        if (res.code == 0) {
          this.$message.success('创建任务成功，请等待上传成功')
          this.selectItems = []
          this.fetchData()
        }
      })
    },
    linkToInfo(val) {
      console.log(val)
    },
    selectTab(val) {
      console.log(val, 11)
      const index = this.selectItems.indexOf(val)
      if (index === -1) {
        this.selectItems.push(val)
      } else {
        this.selectItems.splice(index, 1)
      }
    },
    fetchPageSize(data) {
      this.selectItems = []
      this.query.pageSize = data
      if (this.currentFetchMethod === 'list') {
        this.list()
      } else if (this.currentFetchMethod === 'moreList') {
        this.moreList()
      }
    },
    fetchCurrentPage(data) {
      this.selectItems = []
      this.query.page = data
      if (this.currentFetchMethod === 'list') {
        this.list()
      } else if (this.currentFetchMethod === 'moreList') {
        this.moreList()
      }
    },
    itemInfo(val) {
      console.log(val)
      this.info_visible = true
      this.$nextTick(() => {
        this.$refs.matinfo.send(val)
      })
    },
    handleToggleAll(val) {
      if (val) {
        this.selectItems = this.generateAllItems()
      } else {
        this.selectItems = []
      }
    },
    generateAllItems() {
      // eslint-disable-next-line eqeqeq
      return this.table_data.filter(item => item.upload_status != 1)
    }
  }
}
</script>

<style scoped>
.custom-tabs {
  display: flex;
  align-items: center;
  font-size: 16px;
  color: #666;
}

.tab-item {
  margin-right: 30px;
  height: 50px;
  padding: 8px 0;
  cursor: pointer;
  position: relative;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}

.tab-item.active {
  color: #1677ff;
  font-weight: 500;
}

.tab-item.active::after {
  content: '';
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 100%;
  height: 2px;
  background: #1677ff;
  border-radius: 2px;
}

.line {
  height: 1px;
  background: #e5e6eb;
  margin-top: 1px;
}
.item_box {
  height: 306px;
  width: 224px;
  border: 1px solid #eaebef;
  border-radius: 4px;
  margin-right: 24px;
  margin-top: 10px;
  cursor: pointer;
  position: relative;
}
.item_box_head {
  height: 226px;
  width: 100%;
  background-color: #f7f8fa;
  text-align: center;
}
.el_img {
  width: 158px;
  height: 226px;
}
.item_box_body {
  margin: 16px 20px;
  height: 48px;
  position: relative;
  background-color: #ffffff;
}
.item_bd_name {
  height: 21px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: #1d2129;
  font-size: 14px;
  display: flex;
  justify-content: space-between;
}
.item_bd_time {
  height: 18px;
  position: absolute;
  bottom: 0;
  width: 150px;
  color: #86909c;
  font-size: 12px;
}
.item_bd_det {
  position: absolute;
  right: 0;
  bottom: 0;
  color: #165dff;
}

.search-container {
  display: flex;
  width: 300px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  overflow: hidden;
}

.search-input {
  flex: 1;
  border: none;
  padding: 8px 12px;
  font-size: 14px;
  outline: none;
}

.search-button {
  background-color: #1890ff;
  color: white;
  border: none;
  padding: 8px 16px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.search-button:hover {
  background-color: #46a6ff;
}

.sticky-header {
  background-color: #fff;
  margin-top: 10px;
  padding: 20px;
  position: sticky;
  top: 85px;
  z-index: 999;
}

.data-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 8px; /* 控制上下间距，不需要左右 padding */
}

.item {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 60px; /* 你可以根据字体大小微调 */
  flex-shrink: 0;
}

.value {
  font-size: 16px;
  font-weight: bold;
  color: #333;
}

.label {
  font-size: 12px;
  color: #999;
  margin-top: 4px;
}

.divider {
  width: 1px;
  height: 30px;
  background-color: #eee;
  flex-shrink: 0;
}
</style>
